import { FC } from 'react';
import Form from 'react-bootstrap/Form';
import { Button, ValidationForm } from '../../atoms';

import { CustomDropdown } from '../../molecules';
import styles from './LandscapeIndicatorContributionOrganism.module.css';
import { VerificationStatusResponseDto } from '../../../store/landscapeAPI/verificationStatus/dto/response/verification-status-response.dto';
import { ValueResponseDto } from '../../../store/landscapeAPI/value/dto/response/value-response.dto';
import dayjs from 'dayjs';
import { DEFAULT_VERIFICATION_STATUS_ID } from '../../../utils/UUID';

interface LandscapeIndicatorContributionOrganismProps {
  verificationStatuses: VerificationStatusResponseDto[];
  data: ValueResponseDto;
  handleOnChange: (data: ValueResponseDto) => void;
  callbackFn: (data: ValueResponseDto) => void;
}

const LandscapeIndicatorContributionOrganism: FC<
  LandscapeIndicatorContributionOrganismProps
> = ({ verificationStatuses, data, handleOnChange, callbackFn }) => {
  const statusItems = verificationStatuses.map((item) => ({
    eventKey: item.id,
    label: item.name,
  }));

  statusItems.splice(0, 0, {
    eventKey: DEFAULT_VERIFICATION_STATUS_ID,
    label: '---',
  });

  const initialStatus = statusItems.find(
    (item) => item.eventKey === data.verificationStatusId
  )?.label;

  const date = new Date(data.date ?? '');
  const formattedDate = dayjs(date).format('YYYY-MM-DD');

  return (
    <div className={styles.wrapper}>
      <ValidationForm onSubmitCallback={() => callbackFn(data)}>
        <Form.Group className="mb-3">
          <Form.Label>Quantity</Form.Label>
          <Form.Control
            type="number"
            onChange={(e) => {
              handleOnChange({
                ...data,
                qty: Number(e.target.value),
              });
            }}
            defaultValue={data.qty ?? ''}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Date Founded</Form.Label>
          <Form.Control
            type="date"
            placeholder="Enter date"
            onChange={(e) => handleOnChange({ ...data, date: e.target.value })}
            value={formattedDate}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Verification Status</Form.Label>
          <CustomDropdown
            initialTitle={initialStatus ?? '---'}
            items={statusItems}
            onSelectOption={(e) => {
              handleOnChange({
                ...data,
                verificationStatusId: e.eventKey,
              });
            }}
          />
        </Form.Group>
        <Button variant="dark" type="submit">
          Save
        </Button>
      </ValidationForm>
    </div>
  );
};

export default LandscapeIndicatorContributionOrganism;
